import { useAppSelector } from 'hooks';
import { selectScreenReaderNotifications } from 'reducers/workflows';

// Have to keep old notifications in the state and append new ones.
// Otherwise, screen reader might not read a new notification if it's the same
// as the previous one.
// Screen reader will read only NEW notifications when they get rendered
// (it will not reread old ones).
export default function ScreenReaderNotifications(): JSX.Element {
  const notifications = useAppSelector(selectScreenReaderNotifications);

  return (
    <div aria-live='assertive' className='visually-hidden'>
      {notifications.map((notification, index) => (
        <p key={index}>{notification}</p>
      ))}
    </div>
  );
}
